import { render, staticRenderFns } from "./jkyProjectSelect.vue?vue&type=template&id=274f52dd&scoped=true"
import script from "./jkyProjectSelect.vue?vue&type=script&lang=js"
export * from "./jkyProjectSelect.vue?vue&type=script&lang=js"
import style0 from "./jkyProjectSelect.vue?vue&type=style&index=0&id=274f52dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f52dd",
  null
  
)

export default component.exports